<template>
  <SuggestField v-bind="$attrs" v-on="$listeners" :loader="loadData" @blur="$emit('blur')">
    <template #item="data">
      <v-list-item-content v-if="data.item.name" :title="data.item.name" @click="onSelect(data.item)">
        <v-list-item-title class="dadata-name"  v-text="data.item.shortName"></v-list-item-title>
        <v-list-item-subtitle >
          ИНН: {{ data.item.inn }} КПП: {{ data.item.kpp }} ОГРН: {{ data.item.ogrn }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-content v-else>{{ data.item }}</v-list-item-content>
    </template>
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <template v-for="(_, slot) of $slots" v-slot:[slot]>
      <slot :name="slot" />
    </template>
  </SuggestField>
</template>

<script>
import { findDadataOrg, findDadataOrgById } from '@/api/dadata';
import SuggestField from './SuggestField';

export default {
  name: 'DadataOrgField',
  components: {SuggestField},
  data: () => ({
    loadData: findDadataOrg,
  }),
  methods: {
    onSelect(item) {
      if(!item.inn || item.email) {
        this.$emit('suggest', item);
        return;
      }
      
      let found = item;
      findDadataOrgById(item.inn).then((resp) => {
        if(resp[0]) found = resp[0];
        return resp;        
      }).finally(() => {
        this.$emit('suggest', found);
      })
    }
  }
};
</script>


<style scoped lang="scss">
.dadata-name {
  white-space: normal;
  overflow: hidden;
  max-height: 2.5em;
  text-overflow: ellipsis;
}
</style>
